"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./AutosuggestTextField.css");
var TextField_1 = require("../TextField/TextField");
var key_press_1 = require("../../../utils/key-press");
var AutosuggestTextField = /** @class */ (function (_super) {
    __extends(AutosuggestTextField, _super);
    function AutosuggestTextField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: '',
            isOpen: false,
            suggestions: [],
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onClear = _this.onClear.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.onClickOutSide = _this.onClickOutSide.bind(_this);
        return _this;
    }
    AutosuggestTextField.prototype.componentDidUpdate = function () {
        if (this.state.isOpen) {
            window.document.addEventListener('click', this.onDocumentClick);
            return;
        }
        this.clearOutsideHandler();
    };
    AutosuggestTextField.prototype.componentWillUnmount = function () {
        this.clearOutsideHandler();
    };
    AutosuggestTextField.prototype.clearOutsideHandler = function () {
        document.removeEventListener('click', this.onDocumentClick);
    };
    AutosuggestTextField.prototype.onDocumentClick = function (e) {
        this.onClickOutSide(e);
    };
    AutosuggestTextField.prototype.onClickOutSide = function (e) {
        e.stopPropagation();
        var target = document.activeElement;
        if (target.value && target.value === this.state.currentValue) { // clicked on TextField
            return;
        }
        this.setState({ isOpen: false });
    };
    AutosuggestTextField.prototype.escapeRegexCharacters = function (str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    AutosuggestTextField.prototype.onChange = function (e) {
        if (!e.currentTarget.value.length) {
            this.onClear();
            return;
        }
        this.setSuggestions(e.currentTarget.value);
    };
    AutosuggestTextField.prototype.onClear = function () {
        this.setState({ suggestions: [], currentValue: '', isOpen: false });
    };
    AutosuggestTextField.prototype.onKeyDown = function (e) {
        var isOpen = this.state.isOpen;
        if (!isOpen) {
            return false;
        }
        var focusElem = null;
        if (key_press_1.KeyPress.escIsPressed(e)) { // esc key
            return this.setState({ isOpen: false });
        }
        if (key_press_1.KeyPress.downArrowIsPressed(e) || key_press_1.KeyPress.upArrowIsPressed(e)) {
            e.preventDefault();
            var li = e.currentTarget.querySelector("." + styles.active);
            if (li) {
                if (key_press_1.KeyPress.downArrowIsPressed(e)) {
                    focusElem = li.nextElementSibling;
                }
                else { // up arrow
                    focusElem = li.previousElementSibling;
                }
            }
            else {
                focusElem = e.currentTarget.querySelector("." + styles.suggestionOptionsItem);
            }
            if (focusElem) {
                var elIndex = Array.from(focusElem.parentElement.children).indexOf(focusElem);
                this.setState({ requestedIndex: elIndex });
            }
        }
        else if (key_press_1.KeyPress.enterIsPressed(e)) {
            if (this.state.requestedIndex !== undefined) {
                this.onSelect(this.state.suggestions[this.state.requestedIndex]);
            }
        }
    };
    AutosuggestTextField.prototype.onSelect = function (suggestion) {
        this.setState({
            currentValue: Object.values(suggestion).join(' '),
            isOpen: false,
            requestedIndex: undefined,
            suggestions: [],
        });
        if (this.props.events && this.props.events.onSelect) {
            this.props.events.onSelect(suggestion);
        }
    };
    AutosuggestTextField.prototype.setStaticSuggestions = function (value) {
        var escapedValue = this.escapeRegexCharacters(value.trim());
        if (escapedValue === '') {
            return;
        }
        var regex = new RegExp('^' + escapedValue, 'i');
        var result = [];
        this.props.data.suggestions.forEach(function (suggestion) {
            var fullSuggestion = suggestion.first + suggestion.second + suggestion.third;
            if (regex.test(fullSuggestion)) {
                result.push(suggestion);
            }
        });
        this.setState({ suggestions: result, currentValue: value, isOpen: result.length > 0, requestedIndex: undefined });
    };
    AutosuggestTextField.prototype.setDynamicSuggestions = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var response, suggestionsResponse, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.data.url && this.props.data.clientGet && this.props.data.normalizer)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.data.clientGet(this.props.data.url + value)];
                    case 2:
                        response = _a.sent();
                        suggestionsResponse = this.props.data.normalizer(response);
                        this.setState({
                            currentValue: value,
                            isOpen: suggestionsResponse.length > 0,
                            requestedIndex: undefined,
                            suggestions: suggestionsResponse,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AutosuggestTextField.prototype.setSuggestions = function (value) {
        if (this.props.data.suggestions && this.props.data.suggestions.length > 0) {
            this.setStaticSuggestions(value);
        }
        else {
            this.setDynamicSuggestions(value);
        }
    };
    AutosuggestTextField.prototype.renderSuggestions = function () {
        var _this = this;
        if (this.state.suggestions && this.state.suggestions.length > 0 && this.state.isOpen) {
            var suggestions = this.state.suggestions.map(function (suggestion, index) {
                var onSelect = _this.onSelect.bind(_this, suggestion);
                var isActive = _this.state.requestedIndex === index;
                var selectedClass = isActive ? styles.active : '';
                return (React.createElement("li", { className: [styles.suggestionOptionsItem, selectedClass].join(' '), key: index, onClick: onSelect, role: "menuitem", "aria-label": Object.values(suggestion).join(' '), "aria-selected": isActive },
                    React.createElement("span", null, suggestion.first),
                    suggestion.second && React.createElement("span", null, suggestion.second),
                    suggestion.third && React.createElement("span", null, suggestion.third)));
            });
            return (React.createElement("div", { className: styles.suggestionsContainer, role: "combobox", "aria-label": "combobox", "aria-autocomplete": "list", "aria-haspopup": "true" },
                React.createElement("ul", { className: styles.suggestionOptions, role: "menu" }, suggestions)));
        }
        return null;
    };
    AutosuggestTextField.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.autoSuggestTextField, onKeyDown: this.onKeyDown },
            React.createElement(TextField_1.default, { data: { input: this.state.currentValue }, options: this.props.options, events: { onChange: this.onChange, onClear: this.onClear } }),
            this.renderSuggestions()));
    };
    return AutosuggestTextField;
}(React.Component));
exports.default = AutosuggestTextField;
//# sourceMappingURL=AutosuggestTextField.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/AutosuggestTextField/AutosuggestTextField.js
// module id = 1030
// module chunks = 8